import { validateCanonicalDataset } from './schema.js';

export const CANONICAL_PERSISTENCE_FORMAT = 'metricus-canonical-process';
export const CANONICAL_PERSISTENCE_VERSION = 1;
export const CANONICAL_STORAGE_PREFIX = 'canonical_';

export function getCanonicalStorageId(modelId) {
  const id = String(modelId ?? '').trim();
  if (!id) throw new Error('modelId is required for canonical persistence');
  return `${CANONICAL_STORAGE_PREFIX}${id}`;
}

export function createCanonicalPersistenceEnvelope(dataset, metadata = {}) {
  const validation = validateCanonicalDataset(dataset);
  if (!validation.valid) {
    throw new Error(`Cannot persist invalid canonical dataset: ${validation.errors.join('; ')}`);
  }

  return {
    format: CANONICAL_PERSISTENCE_FORMAT,
    persistenceVersion: CANONICAL_PERSISTENCE_VERSION,
    schemaVersion: dataset.schemaVersion,
    savedAt: metadata.savedAt || new Date().toISOString(),
    metadata: { ...metadata, savedAt: undefined },
    dataset,
  };
}

export function serializeCanonicalDataset(dataset, metadata = {}) {
  return JSON.stringify(createCanonicalPersistenceEnvelope(dataset, metadata));
}

export function parseCanonicalPersistenceEnvelope(value, { validate = true } = {}) {
  const envelope = typeof value === 'string' ? JSON.parse(value) : value;
  if (!envelope || typeof envelope !== 'object') throw new Error('Canonical persistence payload must be an object');
  if (envelope.format !== CANONICAL_PERSISTENCE_FORMAT) {
    throw new Error(`Unsupported canonical persistence format: ${envelope.format || '(missing)'}`);
  }
  if (Number(envelope.persistenceVersion) !== CANONICAL_PERSISTENCE_VERSION) {
    throw new Error(`Unsupported canonical persistence version: ${envelope.persistenceVersion || '(missing)'}`);
  }
  if (!envelope.dataset) throw new Error('Canonical persistence payload has no dataset');

  if (validate) {
    const result = validateCanonicalDataset(envelope.dataset);
    if (!result.valid) throw new Error(`Persisted canonical dataset is invalid: ${result.errors.join('; ')}`);
  }

  return envelope;
}

export function deserializeCanonicalDataset(value, options = {}) {
  return parseCanonicalPersistenceEnvelope(value, options).dataset;
}
